import React from 'react';
import { useTranslation } from 'react-i18next';
import { getGlobalSettingValue, getItemOfSessionStorage, isContainAlphabet } from '../../services/common/utils';
import { getImgSrc } from '../../services/common/CommonUtils';
import { useSelector } from 'react-redux';
import Lottie from "lottie-react";
import PackAndSubscriptionsAction from './pack-and-subscriptions-action';
import dropdown from "../../../src/drop_down.json";
import dropdownup from "../../../src/drop_up.json";
import { SELECTED_LANG } from '../../services/common/Constants';

function PackAndSubscriptions({ linedetailsApi }) {
    const lang = getItemOfSessionStorage(SELECTED_LANG);
    const { t } = useTranslation();
    const [show, setShow] = React.useState();
    const {
        utilityData: { globalSetting },
    } = useSelector((state) => state);
    const settingsArr = globalSetting
        ? globalSetting?.Globalsettings[0]?.items[0]?.metadata
        : [];

    let currentPacks = [];
    let passportList = [];
    let activePacks = [];
    let disabledPacks = [];
    let activeList = [];
    let disabledList = [];
    if (linedetailsApi?.data?.data?.response?.mycurrentpacks?.length > 0) {
        currentPacks = linedetailsApi?.data?.data?.response?.mycurrentpacks;
        passportList = linedetailsApi?.data?.data?.response?.passportList || [];
        activePacks = [...currentPacks];
        disabledPacks = [...currentPacks];

        function filterData(data, type) {
            return currentPacks.filter(
                x =>
                    x?.rncategory ===
                    // rncategory
                    type
            );
        }

        for (let i = 0; i < currentPacks?.length; i++) {
            for (let a = 0; a < passportList.length; a++) {
                if (passportList[a].offerid != null) {
                    if (
                        passportList[a].offerid == currentPacks[i].offerId &&
                        passportList[a]?.autorenewal == false
                    ) {
                        activePacks.splice(i, 1);
                        disabledPacks[i].iscancellable = 'false';
                    }
                }
            }
        }

        activeList = filterData(
            activePacks,
            'active'
            // 'active'
        );
        disabledList = filterData(
            disabledPacks,
            'disabled'
            // 'disabled'
        );
    }

    const isSingleList = (activeList?.length === 0 || disabledList?.length === 0);

    return (
        <>
        {(activeList?.length > 0 || disabledList?.length > 0) && 
        <>
            <div class="mt-5 mb-5 text-center" id='packsAndSub'>
                <div class="position-relative">
                    <div class="linedetails_main_sec_br"></div>
                    <div class="linedetails_main_sec">
                        <p class="section_title_light mb-0 subheading-title">{t("packsandsubscriptions")}</p>
                    </div>
                </div>
            </div>
            <div className='white_card dashboard_card mt-3 sprint14-blance-info sprint14_dashboard_usage m-0'>
                <>
                {activeList?.length > 0 && (
                    <div class="balance_section_info">
                                <h5>{getGlobalSettingValue(
                                    'packsub_active_sectionlabel', settingsArr
                                )}</h5>

                        <div class="sprint14-2row">
                            {
                                activeList?.map((item, index, arr) => {
                                    const imagePath = item?.imageurl || item?.image || '/assets/images/app.png';
                                    const isServerUrl = (item?.imageurl || item?.image) ? true : false;

                                    return (
                                        <>
                                            <div class="profile_info_desc">
                                                <div class="d-flex align-items-center">
                                                    <img src={getImgSrc(imagePath, isServerUrl)} alt="pack-icon" title="" height={45} />
                                                    <div class="s-text me-2">
                                                        <h5 style={{ "direction": isContainAlphabet(item?.title) ? "ltr" : "" }}>{item?.title}</h5>
                                                        <p class={`${item?.rnendDate ? 'm-0 p-0' : ''}`}>{item?.rnendDate ? (<>{t("expireson")} {item?.rnendDate}</>) : ``}</p>
                                                    </div>
                                                </div>
                                                {/* <div class={`event_img d-flex ${lang === 'ar' ? 'switch-rotate-180' : ''}`}>
                                                    <div class="cs_toggle_btn">
                                                        <PackAndSubscriptionsAction index={`active_${index}`}
                                                            passportList={
                                                                linedetailsApi?.data?.data?.response?.passportList
                                                            }
                                                            item={item}
                                                            refetch={linedetailsApi?.refetch} />
                                                    </div>
                                                </div> */}

                                                {/* <div class={`event_img d-flex ${lang === 'ar' ? 'switch-rotate-180' : ''}`}> */}
                                                    {/* <div class="cs_toggle_btn"> */}
                                                        <PackAndSubscriptionsAction index={`active_${index}`}
                                                            passportList={
                                                                linedetailsApi?.data?.data?.response?.passportList
                                                            }
                                                            item={item}
                                                            refetch={linedetailsApi?.refetch} />
                                                    {/* </div> */}
                                                {/* </div> */}
                                            </div>

                                            {
                                                (index + 1) !== arr.length && (
                                                    <hr />
                                                )
                                            }
                                        </>
                                    )
                                })
                            }
                        </div>
                    </div>
                    )}

                    {disabledList?.length > 0 && (<div class={`usage_list balance_section_info packs-sub-list ${(disabledList?.length > 0 && !isSingleList) ? 'mt-4' : ''} ${(show || isSingleList) ? "expand" : ""}`} >
                        
                                <h5>{getGlobalSettingValue(
                                    'packsub_inactive_sectionlabel', settingsArr
                                )}</h5>


                        <div class="sprint14-2row">
                            {
                                disabledList?.map((item, index, arr) => {
                                    const imagePath = item?.imageurl || item?.image || '/assets/images/app.png';
                                    const isServerUrl = (item?.imageurl || item?.image) ? true : false;

                                    return (
                                        <>
                                            <div class="profile_info_desc">
                                                <div class="d-flex align-items-center">
                                                    <img src={getImgSrc(imagePath, isServerUrl)} alt="pack-icon" title="" height={45} />
                                                    <div class="s-text me-2">
                                                        <h5 style={{ "direction": isContainAlphabet(item?.title) ? "ltr" : "" }}>{item?.title}</h5>
                                                        <p class={`${item?.rnendDate ? 'm-0 p-0' : ''}`}>{item?.rnendDate ? (<>{t("expireson")} {item?.rnendDate}</>) : ``}</p>
                                                    </div>
                                                </div>
                                                {/* <div class={`event_img d-flex ${lang === 'ar' ? 'switch-rotate-180' : ''}`}>
                                                    <div class="cs_toggle_btn">
                                                        <PackAndSubscriptionsAction index={`deactive_${index}`}
                                                            passportList={
                                                                linedetailsApi?.data?.data?.response?.passportList
                                                            }
                                                            item={item}
                                                            refetch={linedetailsApi?.refetch} />
                                                    </div>
                                                </div> */}
                                                {/* <div class={`event_img d-flex ${lang === 'ar' ? 'switch-rotate-180' : ''}`}> */}
                                                    {/* <div class="cs_toggle_btn"> */}
                                                        <PackAndSubscriptionsAction index={`deactive_${index}`}
                                                            passportList={
                                                                linedetailsApi?.data?.data?.response?.passportList
                                                            }
                                                            item={item}
                                                            refetch={linedetailsApi?.refetch} />
                                                    {/* </div> */}
                                                {/* </div> */}
                                            </div>

                                            {
                                                (index + 1) !== arr.length && (
                                                    <hr />
                                                )
                                            }
                                        </>
                                    )
                                })
                            }
                        </div>
                    </div>
                    )}
                    {
                      activeList?.length > 0 && disabledList?.length>0 && (
                            <>
                             <div className="flex_grp_center pt-2">
                    <button
                      onClick={() => setShow(!show)}
                      className={`usage_more_btn sprint14-dropdown-arrow ${show ? "open" : ""}`}
                    >
                   {
                      show ? <> 
                      <Lottie animationData={dropdownup} loop={true} 
                      
                         />
                     </>:<>
                     <Lottie animationData={dropdown} loop={true} 
                     
                      />
                      </>

                   }
                    </button>
                  </div>
                            </>
                        )
                    }
                   


                </>
            </div>
        </>
        }</>
    )
}

export default PackAndSubscriptions